import { UploadProjectState } from './types';

const initialState: UploadProjectState = {
  isLoading: false,
  error: '',
  // loaded is needed in order to be able to distinguish
  // uploadProject view from success view
  loaded: false,
};

export default initialState;
